import React from 'react';
import { TruncatedText } from '../../../../../CommonComponents/OPL/Text/TruncatedText';

interface ClickablePositionProps {
  onClick(e): void;
}

export const ClickablePosition: React.FC<ClickablePositionProps> = ({ children, onClick }) => {
  return (
    <TruncatedText
      color="primary.500"
      textAlign="left"
      width="100%"
      ml="40"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={e => {
        if (e.key === ' ' || e.key === 'Enter') {
          onClick(e);
        }
      }}
      css={`
        cursor: pointer;

        &:focus {
          text-decoration: underline;
          outline: none;
        }
      `}
    >
      {children}
    </TruncatedText>
  );
};
